import { IPagination } from "../../../../../types/models/pagination.models.types";
import { ICreator } from "../../../../../types/models/creator.models.types";
import { useGetHttp } from "../../../http.hook";

export interface IGetKycPendingListResponse {
  creators: ICreator[];
  pagination: IPagination;
}

export function useGetPendingGstAdminHttp() {
  return useGetHttp<IGetKycPendingListResponse>({
    path: "/admin/kyc/creator/gst",
  });
}
